import { FarmerPractice } from "./../../../Models/ServerModels/SavedItems/FarmerPractice";

import { BlendStat } from "./../../../Models/ServerModels/Calculations/BlendStat";
import { ChangeRecipeRequest, RecipeItem } from "./../../../Models/ServerModels/Calculations/ChangeRecipeRequest";
import * as Selectors from "./AgriSolutionSelectors";
import GeneralState from "../General";
import AgriSolutionState from ".";
import { MonthTemperature, SavedItemsRequest } from "../../../Models";
import SolutionState from "../Solution";

export const getSavedItemsRequest = (getState: any): SavedItemsRequest => {
  const state = getState();
  const itemId = Selectors.selectItemId(state);
  const itemName = Selectors.selectItemName(state);
  const { activeMetricMethod } = GeneralState.Selectors.selectMetricMethods(state);
  const {
    selectedCrop,
    expectedYield,
    plantingDate,
    finalHarvestDate,
    selectedLocationCountryCode,
    selectedLocationLat,
    selectedLocationLng,
    plotSize,
  } = Selectors.selectCropsState(state);

  const farmState = Selectors.selectFarmState(state);
  const displayReleaseGraphType = Selectors.selectDisplayReleaseGraphType(state);
  const { temperatures, selectedSoil, selectedWater } = Selectors.selectSoilState(state);

  const stepIndexPage = Selectors.selectStepIndexPage(state);
  const isUserSave = Selectors.selectIsUserSave(state);

  const isAgriItem = Selectors.selectIsAgriItem(state);

  const releaseGraphState = Selectors.selectReleaseGraphState(state);

  const temperaturesToReturn: MonthTemperature[] = [];

  temperatures.forEach((temp) => {
    const oneMonth = {
      monthNumber: 0,
      tempatureValue: 0,
      index: 0,
    };
    oneMonth.monthNumber = Number(temp.date);
    oneMonth.tempatureValue = temp.value;
    oneMonth.index = temp.index;
    temperaturesToReturn.push(oneMonth);
  });
  const blendObject = SolutionState.Selectors.selectBlendObject(state);
  const selectedNutrient = SolutionState.Selectors.selectNutrientType(state);
  return {
    savedItemId: itemId,
    name: itemName,
    countryCode: selectedLocationCountryCode as string,
    cropCode: selectedCrop as string,
    plotSize: plotSize as number,
    yieldValue: expectedYield ? expectedYield : null,
    mesurementUnitCode: activeMetricMethod,
    startingDate: plantingDate as string,
    finishDate: finalHarvestDate as string,
    soilId: selectedSoil,
    waterId: selectedWater,
    months: temperaturesToReturn,
    userSaved: isUserSave,
    farmerPractice: farmState.farmerPractice as FarmerPractice,
    cropDemand: farmState.cropDemand.length > 0 ? farmState.cropDemand[0].cropDemand : { n: null, p: null, k: null },
    userShareItem: releaseGraphState.isUserShare,
    step: stepIndexPage == 2.5 ? 5 : stepIndexPage,
    isAgriItem: isAgriItem,
    longitude: selectedLocationLng,
    latitude: selectedLocationLat,
    multicoteBlendId: blendObject && blendObject.id ? blendObject.id : null,
    multicoteNutrientType: selectedNutrient ? selectedNutrient : null,
    displayReadyMadeGraphType: displayReleaseGraphType,
  };
};

export const getChangeRecipeRequest = (getState: any): ChangeRecipeRequest => {
  const state = getState();
  const itemId = Selectors.selectItemId(state);
  const { recipe } = AgriSolutionState.Selectors.selectCustomizedState(state);

  const newRecipe: RecipeItem[] = [];
  recipe.coated.forEach((coated: BlendStat) => {
    const item: RecipeItem = {
      IsCoated: true,
      FertilizerId: Number(coated.id),
      Precentage: coated.precentage,
    };
    newRecipe.push(item);
  });
  recipe.unCoated.forEach((uncoated: BlendStat) => {
    const item: RecipeItem = {
      IsCoated: false,
      FertilizerId: Number(uncoated.id),
      Precentage: uncoated.precentage,
    };
    newRecipe.push(item);
  });
  const { temperatures } = Selectors.selectSoilState(state);

  const temperaturesToReturn: MonthTemperature[] = [];

  temperatures.forEach((temp: { date: number; value: number; index: number }) => {
    const oneMonth = {
      monthNumber: 0,
      tempatureValue: 0,
      index: 0,
    };

    oneMonth.monthNumber = temp.date;
    oneMonth.tempatureValue = temp.value;
    oneMonth.index = temp.index;
    temperaturesToReturn.push(oneMonth);
  });

  return {
    SavedItemId: Number(itemId),
    Months: temperaturesToReturn,
    Recipe: newRecipe,
  };
};

export const getSavedObjRequest = (getState: any) => {
  const state = getState();
  const itemId = Selectors.selectItemId(state);
  const { activeMetricMethod } = GeneralState.Selectors.selectMetricMethods(state);

  const { selectedCrop, expectedYield, plantingDate, finalHarvestDate, selectedLocationCountryCode } = Selectors.selectCropsState(state);

  const { temperatures, selectedSoil, selectedWater } = Selectors.selectSoilState(state);

  const temperaturesToReturn: MonthTemperature[] = [];
  temperatures.forEach((temp: { date: number; value: number; index: number }) => {
    const oneMonth = {
      monthNumber: 0,
      tempatureValue: 0,
      index: 0,
    };

    oneMonth.monthNumber = temp.date;
    oneMonth.tempatureValue = temp.value;
    oneMonth.index = temp.index;
    temperaturesToReturn.push(oneMonth);
  });

  return {
    savedItemId: itemId,
    countryCode: selectedLocationCountryCode as string,
    cropCode: selectedCrop as string,
    yieldValue: expectedYield ? expectedYield : 0,
    mesurementUnitCode: activeMetricMethod,
    startingDate: plantingDate as string,
    finishDate: finalHarvestDate as string,
    months: temperaturesToReturn,
    soilId: selectedSoil as any,
    waterId: selectedWater as any,
  };
};
